// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const hippopotas: PokeData = {
  "id": 449,
  "name": "hippopotas",
  "height": 8,
  "weight": 495,
  "base_experience": 66,
  "types": [
    PokeType.GROUND
  ],
  "api_moves": [
    "sand-attack",
    "tackle",
    "take-down",
    "double-edge",
    "bite",
    "roar",
    "earthquake",
    "fissure",
    "dig",
    "rest",
    "sandstorm",
    "crunch",
    "yawn",
    "slack-off",
    "sand-tomb",
    "mud-bomb",
    "high-horsepower"
  ],
  "moves": [
    "tackle",
    "bite",
    "earthquake",
    "fissure",
    "sandstorm",
    "crunch",
    "mud-bomb",
    "earth-power",
    "bonemerang",
    "bone-throw",
    "mud-slap",
    "magnitude",
    "mud-shot"
  ],
  "evolution_chain": {
    "id": 233,
    "item": null,
    "species": [
      {
        "name": "hippopotas",
        "order": 469,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "hippowdon",
        "order": 470,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": 449,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 34,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 64,
    "speed": 32,
    "ability_power": 72
  },
  "stat_changes": [],
  "catch_rate": 140,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
